import React from 'react'
import RenderDescricao from './descricao.js'
import RenderNorma from './norma.js'
import RenderNotificacao from './notificacao.js'
import Assinaturas from '../../../Views/Form/Assinaturas'

import { useSelector } from 'react-redux'

import view from './View.js'
import brasao from '../../../../assets/brasao.png'

const AiView = () => {
    const ficha = useSelector((state) => state.addForm.ficha)

    return (
        <>
            {RenderAIs()}
        </>
    )

    function RenderAIs() {
        let partes = []
        if (ficha.aifisio) {
            var data = null
            if (ficha.dadosIniciais[0].data) var data = ficha.dadosIniciais[0].data.slice(0, 4)
            ficha.aifisio.map((el, index) => {
                partes.push(
                    <div style={view.break}>
                        <img src={brasao} style={view.brasao} />
                        <div style={view.fonte}>SERVIÇO PÚBLICO FEDERAL</div>
                        <div style={view.fonte}>CONSELHO REGIONAL DE FISIOTERAPIA E TERAPIA OCUPACIONAL DA 1ª REGIÃO</div>
                        <div style={view.fonte}>CREFITO-1</div>
                        <div style={view.caixa}>
                            <div style={view.fonte}>AUTO DE INFRAÇÃO</div>
                            <div style={view.fonte}>TERMO DE INTIMAÇÃO</div>
                            <div style={view.fonte}>Nº {ficha.dadosEstabelecimento[0].uf || null} {el.numeroai}/{data}</div>
                            <div style={view.borda}></div>
                            <div style={view.id}>{RenderId()}</div>
                            <div style={view.processo}>
                                <div><b>ENDEREÇO:</b> {ficha.dadosEstabelecimento[0].endereco || null}</div>
                                <div><b>CIDADE:</b> {ficha.dadosEstabelecimento[0].municipio || null}</div>
                                <div><b>ESTADO:</b> {ficha.dadosEstabelecimento[0].uf || null}</div>
                                <div><b>CEP:</b> {ficha.dadosEstabelecimento[0].cep || null}</div>
                            </div>
                            <div style={view.borda}></div>
                            <div style={{ textAlign: "left", paddingLeft: "2vw" }}><b>DESCRIÇÃO: </b>{RenderDescricao(ficha, el, data)}</div>
                            <div style={view.borda}></div>
                            <div style={{ textAlign: "left", paddingLeft: "2vw" }}><b>NORMA INFRINGIDA: </b>{RenderNorma(ficha, el, data)}</div>
                            <div style={view.borda}></div>
                            <div style={{ textAlign: "left", paddingLeft: "2vw" }}><b>NOTIFICAÇÃO: </b>{RenderNotificacao(ficha, el, data)}</div>
                            <div style={view.borda}></div>
                            <div style={{ textAlign: "left", paddingLeft: "2vw" }}><b>Sede do CREFITO-1: </b>{RenderSede()}</div>
                            <div style={view.borda}></div>
                            <div style={{ textAlign: "left", paddingLeft: "2vw" }}><b>E-mail:</b> crefito1@crefito1.org.br</div>
                        </div>
                        <div style={view.final}>
                            {ficha.dadosEstabelecimento[0].municipio || null}
                            , {ficha.dadosIniciais[0].data.slice(8, 10) || null}
                            /{ficha.dadosIniciais[0].data.slice(5, 7) || null}
                            /{ficha.dadosIniciais[0].data.slice(0, 4) || null}
                        </div>
                        <Assinaturas profissao="de Fisioterapia" />
                    </div>
                )

                function RenderId() {
                    if (el.tipoinfracao === "3 - Exercício ilegal da profissão de fisioterapeuta.") {
                        return (
                            <>
                                <div><b>Estabelecimento:</b> {el.estabelecimento || null}</div>
                                <div><b>CNPJ:</b> {el.cnpj || null}</div>
                            </>
                        )
                    }
                    else if (el.tipoinfracao === "4 - Prática de atividades da Fisioterapia por pessoa não habilitada.") {
                        return (
                            <>
                                <div><b>Autuado:</b> {el.autuado || null}</div>
                                <div><b>RG:</b> {el.rgleigo || null}</div>
                                <div><b>CPF:</b> {el.cpfleigo || null}</div>
                            </>
                        )
                    }
                    else if (el.tipoinfracao === "8 - Profissional com Licença Temporária de Fisioterapia vencida.") {
                        return (
                            <>
                                <div><b>Autuado:</b> {el.autuado || null}</div>
                            </>
                        )
                    }
                    else if (el.tipoinfracao === "6 - Empresa não possui a Declaração de Regularidade para Funcionamento (DRF) do serviço." ||
                        el.tipoinfracao === "7 - Ausência do responsável técnico de Fisioterapia." ||
                        el.tipoinfracao === "18 - Falta de Registro de Pessoa Jurídica junto ao CREFITO-1." ||
                        el.tipoinfracao === "21 - Falta de cadastro do estabelecimento fiscalizado de Fisioterapia.") {
                        return (
                            <>
                                <div><b>Autuado:</b> {el.autuado || null}</div>
                                <div><b>cnpj:</b> {el.cnpj || null}</div>
                            </>
                        )
                    }
                    else {
                        return (
                            <>
                                <div><b>Autuado:</b> {el.autuado || null}</div>
                                <div><b>Nº de Inscrição:</b> {el.inscricao || null}</div>
                            </>
                        )
                    }
                }

                function RenderSede() {
                    if (ficha.dadosEstabelecimento[0].uf === "PB") {
                        return (
                            <>R. Dr. Arnaldo Escorel, 564 - Tambauzinho, João Pessoa/PB, CEP: 58042-080 / Telefone: (83) 3021-6900</>
                        )
                    }
                    else if (ficha.dadosEstabelecimento[0].uf === "AL") {
                        return (
                            <>Rua Dez de Novembro, 458 - Pitanguinha - Maceió/AL, CEP: 57052-220, Fone: (82) 3221-0756</>
                        )
                    }
                    else if (ficha.dadosEstabelecimento[0].uf === "RN") {
                        return (
                            <>Rua Acarí, 24 - Lagoa Nova - Natal/RN, CEP: 59063-280, Fone: (84) 3201-0607</>
                        )
                    }
                    else if (ficha.dadosEstabelecimento[0].uf === "PE") {
                        return (
                            <>Rua Henrique Dias, 303 - Boa Vista - Recife/PE, CEP: 50070-140, Fone: (81) 3081-5000</>
                        )
                    }
                }
            })
        }
        return partes
    }
}

export default AiView